import React from "react";
import "./BedroomCleaningService.css";

const BedroomCleaningService = () => {
  return (
    <div className="bedroomcleaning-cleaning-container">
      <h1>Relax in a Clean and Calm Bedroom</h1>
      <p>
        We'll dust all surfaces, including furniture and shelves. We'll also
        vacuum or mop floors and clean mirrors and windows. We'll even get
        behind your toilets!
      </p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Dust furniture, shelves, and surfaces</li>
        <li>Vacuum or mop floors</li>
        <li>Clean mirrors and windows</li>
        <li>Dust behind toilets</li>
      </ul>
    </div>
  );
};

export default BedroomCleaningService;
